export default __webpack_public_path__ + "static/media/mid-k-10-med.e3c80042.png";